import { render, staticRenderFns } from "./GscQueries.vue?vue&type=template&id=783737b9&"
import script from "./GscQueries.vue?vue&type=script&lang=js&"
export * from "./GscQueries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('783737b9')) {
      api.createRecord('783737b9', component.options)
    } else {
      api.reload('783737b9', component.options)
    }
    module.hot.accept("./GscQueries.vue?vue&type=template&id=783737b9&", function () {
      api.rerender('783737b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Research/GscQueries.vue"
export default component.exports